import Rodape from "Components/Rodape";
import Topo from "Components/Topo";
import InputMask from "react-input-mask";
import React, { useState, useEffect } from 'react';
import { cpf as cpfValidator } from 'cpf-cnpj-validator';
import validator from 'validator';
import { Navigate } from 'react-router-dom';
import { API_BASE } from "API";
import swal from "sweetalert";
import Helper from "Helper";
import brasilImg from "img/brasil.jpg";
import euaImg from "img/eua.jpg";
import espanhaImg from "img/espanha.jpg";

function Pesquisa(){
    
    const [idioma, setIdioma] = useState('BR');
    const [cpfInput, setCpfInput] = useState('');
    const [emailInput, setEmailInput] = useState('');
    const [nomeInput, setNomeInput] = useState('');
    const [cpfValid, setCpfValid] = useState(false);
    const [emailValid, setEmailValid] = useState(false);
    const [skipFocus, setSkipFocus] = useState(false);
    const [tipoBusca, setTipoBusca] = useState('cpf');
    const [showModal, setShowModal] = useState(false);
    const [resultadosNome, setResultadosNome] = useState([]);

    sessionStorage.removeItem("foto");
    let url = "";

    const opcoesIdioma = {
        BR: {
            label: 'Brasil',
            img: brasilImg,
            opcoes: ['CPF', 'Nome', 'E-mail']
        },
        US: {
            label: 'EUA',
            img: euaImg,
            opcoes: ['Nome', 'E-mail']
        },
        SP: {
            label: 'Espanha',
            img: espanhaImg,
            opcoes: ['Nome', 'E-mail']
        }
    };

    // Reseta o idioma para BR quando o componente monta
    useEffect(() => {
         const params = new URLSearchParams(window.location.search);
         const ehRedirecionamento = params.get('redirect') === 'true';

        if (!ehRedirecionamento) {
            setIdioma('BR');
            sessionStorage.setItem('lng', 'BR');
            sessionStorage.removeItem('cod_categoria');
            sessionStorage.setItem('cod_inscricao', '');
            sessionStorage.setItem('cod_empresa_pj', '');
            // Só limpa cod_empresa se ele estiver vazio ou for uma nova sessão
            if (!sessionStorage.getItem('cod_empresa') || sessionStorage.getItem('cod_empresa') === '') {
                sessionStorage.setItem('cod_empresa', '');
            }
            sessionStorage.setItem('cpf', '');
            sessionStorage.setItem('cpf_cnpj_chave_empresa', '');
            sessionStorage.setItem('email', '');
            sessionStorage.setItem('cod_categoria','');
        }
    }, []);

    // Sincroniza o sessionStorage quando idioma muda
    useEffect(() => {
        sessionStorage.setItem('lng', idioma);
    }, [idioma]);

    const handleIdiomaChange = (novoIdioma) => {
        setIdioma(novoIdioma);
        setCpfInput('');
        setEmailInput('');
        setNomeInput('');
        setCpfValid(false);
        setEmailValid(false);
        setTipoBusca(novoIdioma === 'BR' ? 'cpf' : 'nome');
    };

    const handleCpfChange = (event) => {
        const inputValue = event.target.value || '';
        setCpfInput(inputValue);
        setCpfValid(cpfValidator.isValid(inputValue));
    };

    const handleEmailChange = (event) => {
        const inputValue = event.target.value || '';
        setEmailInput(inputValue);
        setEmailValid(validator.isEmail(inputValue));
    };

    const handleNomeChange = (event) => {
        const inputValue = event.target.value || '';
        setNomeInput(inputValue);
    };

    const handleTipoBuscaChange = (event) => {
        setTipoBusca(event.target.value);
        setCpfInput('');
        setNomeInput('');
        setEmailInput('');
        setCpfValid(false);
        setEmailValid(false);
    };

    useEffect(() => {
        if (!skipFocus) {
            let fieldId = '';
            if (tipoBusca === 'cpf') fieldId = 'cpf';
            else if (tipoBusca === 'email') fieldId = 'email';
            else if (tipoBusca === 'nome') fieldId = 'nome';

            const inputField = document.getElementById(fieldId);
            if (inputField && Helper.validaLogin()) {
                inputField.focus();
            }
        }
    }, [skipFocus, tipoBusca]);

    const handleCpfSelecionado = (cod_empresa) => {
        setSkipFocus(true);
        setTimeout(() => {
            if(undefined != cod_empresa && null != cod_empresa && "" != cod_empresa){
               
                sessionStorage.setItem("cod_empresa", cod_empresa);
                
                window.location.href = "/Cadastro?redirect=true";
            }
        }, 500);
    };

    const handleNomeClick = (pais, cod_empresa, cod_categoria, idioma) => {
        //setShowModal(false);
        //console.log(pais, cod_empresa, cod_categoria, idioma);
        //return false;
        if(cod_empresa) {
            sessionStorage.setItem("cod_empresa", cod_empresa);
            if(cod_categoria && null != cod_categoria && undefined != cod_categoria && "" != cod_categoria ) {
            sessionStorage.setItem('cod_categoria', cod_categoria);
            }

             if(idioma && null != idioma && undefined != idioma && "" != idioma ) {
            sessionStorage.setItem('lng', idioma);
            }
            sessionStorage.removeItem('cpf');
             window.location.href = "/Cadastro?redirect=true";
        }
    };

    const buscarPorNome = async () => {
        sessionStorage.removeItem('cpf');
        if(!nomeInput || nomeInput.trim().length < 3) {
            alert('Digite pelo menos 3 caracteres para buscar por nome');
            return;
        }

        try {
            document.getElementById("btn_buscar").textContent = "Aguarde...";

            const url = API_BASE + "getPequisaPorNome.php?nome=" + encodeURIComponent(nomeInput) + 
                        "&access_token=" + sessionStorage.getItem("token") + 
                        "&id_user=" + sessionStorage.getItem('nome_usser') + 
                        "&cod_usser=" + sessionStorage.getItem('cod_usser');

                         if(sessionStorage.getItem('md') == 'dev'){
                            console.log(url);
                         }

            const response = await fetch(url);
            const text = await response.text();
             const cleanText = text.replace(/^\uFEFF/, '');
            const data = JSON.parse(cleanText);

            document.getElementById("btn_buscar").textContent = "Buscar";

            if(Array.isArray(data) && data.length > 0) {
                if(data.length == 1) {
                    if(data[0].cod_empresa && null != data[0].cod_empresa && undefined != data[0].cod_empresa && "" != data[0].cod_empresa ) {
                        sessionStorage.setItem("cod_empresa", data[0].cod_empresa);
                        if(data[0].cod_categoria && null != data[0].cod_categoria && undefined != data[0].cod_categoria && "" != data[0].cod_categoria ) {
                            sessionStorage.setItem('cod_categoria', data[0].cod_categoria);
                        }
                        if(data[0].idioma && null != data[0].idioma && undefined != data[0].idioma && "" != data[0].idioma ) {
                            sessionStorage.setItem('lng', data[0].idioma);
                        }
                        window.location.href = "/Cadastro";
                    }
                } else {
                    setResultadosNome(data);
                    setShowModal(true);
                }
            } else {
                swal("Nenhum cadastro encontrado com esse nome", "", "info");
            }
        } catch(error) {
            console.log(error);
            document.getElementById("btn_buscar").textContent = "Buscar";
            swal("Erro ao buscar por nome", "", "error");
        }
    };

    const verificaInscricao = async (url) => {
        try {
            const response = await fetch(url);
            const text = await response.text();
             const cleanText = text.replace(/^\uFEFF/, '');
            const data = JSON.parse(cleanText);
            console.log('data:',data);
            if(data.status.duplicidade){
                swal(data.status.msg, "", "error");
                setCpfInput('');
                setEmailInput('');
                setNomeInput('');
                setCpfValid(false);
                setEmailValid(false);
                document.getElementById("btn_buscar").textContent = "Buscar";
                return false; 
            }
            else{
               if(sessionStorage.getItem('md') == 'dev'){
                    console.log(data);
               }
                
                if(data.cadastro && data.cadastro[0] && data.cadastro[0].idioma != sessionStorage.getItem("lng")){
                        // Ajuste para atualizar o idioma e trazer as categorias corretas
                        console.log('Trocando:',sessionStorage.getItem("lng"),data.cadastro[0].idioma);
                        sessionStorage.setItem("lng",data.cadastro[0].idioma);
                        
                }

                if(data.cadastro && data.cadastro[0] && data.cadastro[0].destino == 'CREDENCIAL'){
                    if(data.cadastro[0].cod_inscricao){
                        sessionStorage.setItem('cod_inscricao', data.cadastro[0].cod_inscricao);
                    }
                    if(data.cadastro[0].cod_empresa){
                        sessionStorage.setItem("cod_empresa", data.cadastro[0].cod_empresa);
                    }
                    window.location.href = '/Inscricao';
                }
                else if(data.cadastro && data.cadastro[0] && data.cadastro[0].destino == 'VENDA'){
                    if(data.cadastro[0].cod_inscricao){
                        sessionStorage.setItem('cod_inscricao', data.cadastro[0].cod_inscricao);
                    }
                    if(data.cadastro[0].cod_empresa){
                        sessionStorage.setItem("cod_empresa", data.cadastro[0].cod_empresa);
                    }
                    window.location.href = '/VendaRapida';
                }
                else{
                    if(data.cadastro && data.cadastro[0] && data.cadastro[0].cod_inscricao){
                        sessionStorage.setItem('cod_inscricao', data.cadastro[0].cod_inscricao);
                    }
                    
                    window.location.href = '/Cadastro';
                }
            } 
        } catch(error){
            console.log(error);
            document.getElementById("btn_buscar").textContent = "Buscar";
        }
    }

    const handleSubmit = (event) => {
        if(!Helper.validaToken()){
            swal("Token Expirado, acesse o link principal novamente", "", "error");
            return false;
        }
        if(!Helper.validaLogin()){
            swal("Login Expirado, acesse o link principal novamente", "", "error");
            return false;
        }

        event.preventDefault();

        document.getElementById("btn_buscar").textContent = "Aguarde...";

        // Busca por Nome
        if(tipoBusca === 'nome') {
            buscarPorNome();
            return;
        }

        // Busca por CPF
        if(tipoBusca === 'cpf') {
            let isCpfValid = cpfValidator.isValid(cpfInput);
            if(isCpfValid) {
                sessionStorage.setItem('cpf', cpfInput.replace(/[^0-9]/g, ''));
                sessionStorage.setItem('email', '');
                url = API_BASE + "getCadastro.php?cpf=" + cpfInput.replace(/[^0-9]/g, '') + "&email=&access_token=" + sessionStorage.getItem("token") + "&id_user=" + sessionStorage.getItem('nome_usser') + "&cod_usser=" + sessionStorage.getItem('cod_usser')+"&lng="+sessionStorage.getItem('lng')+"&cod_categoria="+"&cod_categoria="+(sessionStorage.getItem("cod_categoria")?sessionStorage.getItem("cod_categoria"):'');
                verificaInscricao(url);
            } else {
                document.getElementById("btn_buscar").textContent = "Buscar";
                alert('Digite um CPF Válido');
            }
            return;
        }

        // Busca por E-mail
        if(tipoBusca === 'email') {
            let isEmailValid = validator.isEmail(emailInput);
            if(isEmailValid) {
                sessionStorage.setItem('email', emailInput);
                sessionStorage.setItem('cpf', '');
                url = API_BASE + "getCadastro.php?cpf=&email=" + emailInput + "&access_token=" + sessionStorage.getItem("token") + "&id_user=" + sessionStorage.getItem('nome_usser') + "&cod_usser=" + sessionStorage.getItem('cod_usser')+"&lng="+sessionStorage.getItem('lng')+"&cod_categoria="+(sessionStorage.getItem("cod_categoria")?sessionStorage.getItem("cod_categoria"):'');
                verificaInscricao(url);
            } else {
                document.getElementById("btn_buscar").textContent = "Buscar";
                alert('Digite um e-mail válido');
            }
            return;
        }
    };

    const getPlaceholder = () => {
        if(tipoBusca === 'cpf') return '000.000.000-00';
        if(tipoBusca === 'email') return 'seu@email.com';
        return 'Digite o nome';
    };

    const getTitulo = () => {
        if(tipoBusca === 'cpf') return 'Digite o CPF';
        if(tipoBusca === 'email') return 'Digite o E-mail';
        return 'Digite o Nome';
    };

    const getLarguraInput = () => {
        return tipoBusca === 'nome' ? 'w-96' : 'w-80';
    };

    return (
        <>
        <Topo texto="Pesquisa" cor_fundo="bg-sky-500" cor_texto="text-white" onCpfSelecionado={handleCpfSelecionado}></Topo>

        <form onSubmit={handleSubmit}>
        <div className="flex flex-col justify-center items-center h-auto py-8">

            {/* Seletor de Idioma com Bandeiras */}
            <div className="flex justify-center items-center gap-6 mb-8">
    {Object.entries(opcoesIdioma).map(([key, config]) => (
        <button
            key={key}
            type="button"
            onClick={() => handleIdiomaChange(key)}
            className={`relative transition-all p-2 ${idioma === key ? 'ring-8 ring-black rounded' : 'scale-75'}`}
        >
            <img 
                src={config.img} 
                alt={config.label}
                className="h-12 w-16 object-cover rounded cursor-pointer hover:opacity-80"
                title={config.label}
            />
        </button>
    ))}
</div>

            {/* Título "Buscar Por" */}
            <div className="flex justify-center items-center gap-6 mb-4">
                <span className="text-gray-700 font-semibold text-lg">Buscar Por</span>
            </div>

            {/* Radio Buttons para escolher tipo de busca */}
            <div className="flex justify-center items-center gap-6 mb-6">
                {opcoesIdioma[idioma] && opcoesIdioma[idioma].opcoes.map((opcao) => {
                    const value = opcao === 'CPF' ? 'cpf' : opcao === 'E-mail' ? 'email' : 'nome';
                    return (
                        <label key={value} className="flex items-center cursor-pointer">
                            <input 
                                type="radio" 
                                name="tipoBusca" 
                                value={value}
                                checked={tipoBusca === value}
                                onChange={handleTipoBuscaChange}
                                className="form-radio h-5 w-5 text-sky-500"
                                autoComplete="off"
                            />
                            <span className="ml-2 text-gray-700 font-semibold">{opcao}</span>
                        </label>
                    );
                })}
            </div>

            {/* Título dinâmico */}
            <div className="flex justify-center items-center text-sky-500 font-bold text-xl p-4 mb-4">
                {getTitulo()}
            </div>

            {/* Campo de entrada */}
            <table className={`m-4 bg-sky-500 h-14 ${getLarguraInput()}`}>
            <tbody>
                <tr>
                    <td>
                    {tipoBusca === 'cpf' ? (
                        <InputMask 
                            key='cpf'
                            mask="999.999.999-99" 
                            id="cpf" 
                            type="tel" 
                            placeholder={getPlaceholder()}
                            className={!cpfValid && cpfInput ? 'w-52 h-9 ml-3 text-center border border-red-500' : 'w-52 h-9 ml-3 text-center'}  
                            value={cpfInput}
                            onChange={(e) => {
                                if (!e || !e.target) return;
                                handleCpfChange(e);
                            }}
                            autoComplete="off"
                        />
                    ) : tipoBusca === 'email' ? (
                        <input 
                            key='email'
                            id="email" 
                            type="email" 
                            placeholder={getPlaceholder()}
                            className={!emailValid && emailInput ? 'w-96 h-9 ml-3 text-left border border-red-500' : 'w-96 h-9 ml-3 text-left'}
                            value={emailInput}
                            onChange={(e) => {
                                if (!e || !e.target) return;
                                handleEmailChange(e);
                            }}
                            autoComplete="off"
                        />
                    ) : (
                        <input 
                            key='nome'
                            id="nome" 
                            type="text" 
                            placeholder={getPlaceholder()}
                            className='w-72 h-9 ml-3 text-left'
                            value={nomeInput}
                            onChange={handleNomeChange}
                            autoComplete="off"
                        />
                    )}
                    </td>
                    <td className="pr-3">
                        <button 
                            type="submit"
                            className="border w-20 h-9 text-white ml-2 bg-blue-600 hover:bg-blue-700" 
                            id="btn_buscar"
                        >
                            Buscar
                        </button>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
        </form>

        {/* Modal de Resultados */}
        {showModal && resultadosNome.length > 0 && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-xl w-11/12 max-w-4xl max-h-[80vh] flex flex-col">
                    <div className="bg-sky-500 text-white p-4 rounded-t-lg flex justify-between items-center">
                        <h2 className="text-xl font-bold">Resultados da Busca</h2>
                        <button 
                            type="button"
                            onClick={() => setShowModal(false)}
                            className="text-white hover:text-gray-200 text-2xl font-bold"
                        >
                            ×
                        </button>
                    </div>

                    <div className="overflow-auto flex-1 p-4">
                        <table className="w-full border-collapse">
                            <thead className="bg-gray-100 sticky top-0">
                                <tr>
                                    <th className="border p-2 text-left">Nome</th>
                                    <th className="border p-2 text-left">Empresa</th>
                                    <th className="border p-2 text-left">País</th>
                                    <th className="border p-2 text-left">E-mail</th>
                                </tr>
                            </thead>
                            <tbody>
                                {resultadosNome.map((item, index) => (
                                    <tr key={index} className="hover:bg-gray-400 cursor-pointer" onClick={() => handleNomeClick(item.pais, item.cod_empresa, item.cod_categoria, item.idioma)}>
                                        <td className="border p-2 text-left">{item.nome}</td>
                                        <td className="border p-2">{item.empresa || '-'}</td>
                                        <td className="border p-2">{item.pais || '-'}</td>
                                        <td className="border p-2">{item.email || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-4 border-t">
                        <button 
                            type="button"
                            onClick={() => setShowModal(false)}
                            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        )}

        <Rodape passo="1" />
        </>
    )
}

export default Pesquisa;